// React:
import React from "react";
// React-Router-Dom:
import { useNavigate } from "react-router-dom";
// Redux Toolkit Hooks:
import { useAppSelector, useAppDispatch } from "../../../../../../app/hooks";
// Redux Toolkit Actions & State:
import {
  deleteModalOpenAction,
  deleteModalSetActionPathAction,
  deleteModalSetDeleteIdAction,
} from "../../../../../global/delete-modal/deleteModalSlice";
import { directoryItemsTouchedAction, ItemInfo } from "../directoryItemsSlice";
import {
  drawerOpenOrCloseAction,
  drawerItemOpenOrCloseAction,
} from "../../../drawer/drawerSlice";
import { headerHamburgerMenuAction } from "../../../../../global/header/headerSlice";
import { shareManagement } from "../../../../share-management/shareManagementSlice";
// MUI Components:
import { Popover, List, MenuItem, SvgIcon, Typography } from "@mui/material";
// MUI Icones:
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
// Icones:
// import { ReactComponent as DownloadIcon } from "../../../../../../assets/icons/download-icon.svg";
import { ReactComponent as ShareIcon } from "../../../../../../assets/icons/share-icon.svg";
import { ReactComponent as TableIcon } from "../../../../../../assets/icons/table-icon.svg";
import { ReactComponent as TrashIcon } from "../../../../../../assets/icons/trash-icon.svg";

// Type Controller
interface DirectoryItemsOptionProps {
  item: ItemInfo;
  index: number;
  id: "ignoreDisableTouch" | undefined;
  openPopover: boolean;
  popoverOptions: {
    anchorEl: HTMLButtonElement | null;
    popId: number;
  };
  handleClosePopover: (item: ItemInfo, index: number) => void;
}

const items = [
  {
    name: "Detail",
    icon: TuneOutlinedIcon,
  },
  // {
  //   name: "Download",
  //   icon: DownloadIcon,
  // },
  {
    name: "Share",
    icon: ShareIcon,
  },
  {
    name: "Share management",
    icon: TableIcon,
  },
  {
    name: "Delete",
    icon: TrashIcon,
  },
];

const DirectoryItemsOption: React.FC<DirectoryItemsOptionProps> = ({
  item,
  index,
  id,
  openPopover,
  popoverOptions,
  handleClosePopover,
}) => {
  const itemIsFolder = item.dir;

  const optionItems =
    popoverOptions.popId === index && itemIsFolder
      ? [items[0], items[3]]
      : items;

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const {
    shareManagementData: { list },
  } = useAppSelector(shareManagement);

  return (
    <>
      {popoverOptions.popId === index && (
        <Popover
          id={id}
          open={openPopover}
          anchorEl={popoverOptions.anchorEl}
          onClose={(event: any) => {
            event.stopPropagation();
            handleClosePopover(item, index);
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <List sx={{ minWidth: "150px", minHeight: "fit-content", p: "8px" }}>
            {optionItems.map((optionItem, optionIndex) => (
              <MenuItem
                key={optionIndex}
                disabled={
                  optionItem.name === "Share management" && !list?.length
                    ? true
                    : false
                }
                onClick={(event) => {
                  switch (optionItem.name) {
                    case "Detail":
                      event.stopPropagation();
                      dispatch(directoryItemsTouchedAction(true));
                      dispatch(drawerOpenOrCloseAction(true));
                      dispatch(
                        drawerItemOpenOrCloseAction({
                          name: "info",
                          open: true,
                        })
                      );
                      dispatch(headerHamburgerMenuAction(false));
                      handleClosePopover(item, index);
                      break;
                    case "Download":
                      event.stopPropagation();
                      handleClosePopover(item, index);
                      break;
                    case "Share":
                      event.stopPropagation();
                      dispatch(directoryItemsTouchedAction(true));
                      dispatch(drawerOpenOrCloseAction(true));
                      dispatch(
                        drawerItemOpenOrCloseAction({
                          name: "share",
                          open: true,
                        })
                      );
                      handleClosePopover(item, index);
                      break;
                    case "Share management":
                      event.stopPropagation();
                      navigate("/share-management");
                      dispatch(directoryItemsTouchedAction(false));
                      dispatch(drawerOpenOrCloseAction(false));
                      handleClosePopover(item, index);
                      break;
                    case "Delete":
                      event.stopPropagation();
                      dispatch(
                        deleteModalOpenAction({
                          type: item?.dir ? "Directory" : "File",
                        })
                      );
                      dispatch(deleteModalSetActionPathAction("directory"));
                      dispatch(deleteModalSetDeleteIdAction(item.id));
                      handleClosePopover(item, index);
                      break;
                    default:
                      break;
                  }
                }}
                sx={{
                  p: "10px 12px",
                  fontSize: "16px",
                  textAlign: "left",
                  color:
                    item.name !== "Delete"
                      ? (theme) => theme.palette.text.secondary
                      : "#E36464",
                }}
              >
                <SvgIcon
                  component={optionItem.icon}
                  inheritViewBox
                  sx={{
                    width: "20px",
                    height: "20px",
                    color: optionItem.name === "Delete" ? "#E36464" : "inherit",
                    mr: "8px",
                  }}
                />

                <Typography
                  sx={{
                    fontSize: "17px",
                    color: optionItem.name === "Delete" ? "#E36464" : "inherit",
                  }}
                >
                  {optionItem.name}
                </Typography>
              </MenuItem>
            ))}
          </List>
        </Popover>
      )}
    </>
  );
};

export default DirectoryItemsOption;
